import { render, staticRenderFns } from "./dialog-tertiary.vue?vue&type=template&id=1248e4fb&scoped=true"
import script from "./dialog-tertiary.vue?vue&type=script&lang=js"
export * from "./dialog-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248e4fb",
  null
  
)

export default component.exports